import { render } from "./CertificatesManager.vue?vue&type=template&id=0cb4087e"
import script from "./CertificatesManager.vue?vue&type=script&lang=js"
export * from "./CertificatesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__